<div class="contact-crud-modal">
  <div class="contact-crud-modal-header">
    <h5>
      @if (deleteContact) {
        {{ 'fgbcl.contact.crud.modal.header.delete.title' | translate }}
      } @else {
        @if (isNew) {
          {{ 'fgbcl.contact.crud.modal.header.add.title' | translate }}
        } @else {
          {{ 'fgbcl.contact.crud.modal.header.edit.title' | translate }}
        }
      }
    </h5>
  </div>
  <div class="contact-crud-modal-body">
    @if (deleteContact) {
      <ng-container *ngTemplateOutlet="deleteTemplate"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="addEditTemplate"></ng-container>
    }
  </div>

  <div class="action-wrapper">
    <button class="btn text-danger" (click)="closeModal()">{{ 'fgbcl.contact.crud.modal.cancel.button' | translate }}</button>
    @if (deleteContact) {
      <button class="btn btn-success" (click)="delete()">
        @if (!loading) {
          {{ 'fgbcl.contact.crud.modal.delete.button' | translate }}
        } @else {
          <!-- Spinner if loading -->
          <fgbcl-loading size="small"></fgbcl-loading>
        }
      </button>
    } @else {
      <button class="btn btn-success" (click)="submit()">
        @if (!loading) {
          @if (isNew) {
            {{ 'fgbcl.contact.crud.modal.form.button.add' | translate }}
          } @else {
            {{ 'fgbcl.contact.crud.modal.form.button.edit' | translate }}
          }
        } @else {
          <!-- Spinner if loading -->
          <fgbcl-loading size="small"></fgbcl-loading>
        }
      </button>
    }
  </div>
</div>

<!-- Add or Update form -->
<ng-template #addEditTemplate>
  <form class="contact-crud-modal-form" [formGroup]="contactForm">
    <div class="form-group">
      <div class="form-floating">
        <input type="text" class="form-control" formControlName="FullName" id="FullName" placeholder="Full Name" />
        <label for="FullName">{{ 'fgbcl.contact.crud.modal.form.fullname.label' | translate }}</label>
      </div>
      <div
        class="error-message"
        *ngIf="contactForm.get('FullName')?.hasError('required') && contactForm.get('FullName')?.touched"
      >
        {{ 'fgbcl.contact.crud.modal.form.fullname.error.required' | translate }}
      </div>
      <div class="error-message" *ngIf="contactForm.get('FullName')?.hasError('pattern') && contactForm.get('FullName')?.touched">
        {{ 'fgbcl.contact.crud.modal.form.fullname.error.pattern' | translate }}
      </div>
      <div class="error-message" *ngIf="contactForm.get('FullName')?.hasError('empty') && contactForm.get('FullName')?.touched">
        {{ 'fgbcl.contact.crud.modal.form.fullname.error.empty' | translate }}
      </div>
    </div>
    <div class="form-group">
      <div class="form-floating">
        <input type="email" class="form-control" formControlName="EmailAddress" id="EmailAddress" placeholder="Email Address" />
        <label for="EmailAddress">{{ 'fgbcl.contact.crud.modal.form.email.address.label' | translate }}</label>
      </div>
      <div
        class="error-message"
        *ngIf="contactForm.get('EmailAddress')?.hasError('required') && contactForm.get('EmailAddress')?.touched"
      >
        {{ 'fgbcl.contact.crud.modal.form.email.address.error.required' | translate }}
      </div>
      <div
        class="error-message"
        *ngIf="contactForm.get('EmailAddress')?.hasError('contactExist') && contactForm.get('EmailAddress')?.touched"
      >
        {{ 'fgbcl.contact.crud.modal.form.email.address.error.exist' | translate }}
      </div>
      <div
        class="error-message"
        *ngIf="contactForm.get('EmailAddress')?.hasError('pattern') && contactForm.get('EmailAddress')?.touched"
      >
        {{ 'fgbcl.contact.crud.modal.form.email.address.error.pattern' | translate }}
      </div>
    </div>
  </form>
</ng-template>

<!-- Delete Template -->
<ng-template #deleteTemplate>
  <div class="contact-crud-modal-delete-body">
    <p
      class="mb-0"
      [innerHtml]="'fgbcl.contact.crud.modal.delete.message' | translate: { contact: contact } | markdownTranslate"
    ></p>
  </div>
</ng-template>
